import StoredLayout from '../../layouts/StoredLayout'
import Credits from './Credits'
export default StoredLayout(Credits)



// WEBPACK FOOTER //
// ./src/documentation/credits/index.js